import angular from 'angular';

const shoppingListsServices = angular.module('applicationModule.shoppingListsServices', []);

shoppingListsServices.factory('ShoppingLists', ['ShoppingListsAPI', function (ShoppingListsAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return ShoppingListsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },

        get: function (listId, appId) {
            return ShoppingListsAPI.get(listId, appId);
        },
        post: function (list) {
            return ShoppingListsAPI.createCategory(list);
        },
        save: function (list, editMode) {
            if (editMode) {
                return ShoppingListsAPI.editShoppingList(list);
            } else {
                return ShoppingListsAPI.createShoppingList(list);
            }
        },
        remove: function (categoryId) {
            return ShoppingListsAPI.remove(categoryId);
        }
    };
}]);

shoppingListsServices.service('ShoppingListsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const SHOPPING_LIST_URL = AppsoupAPI.API_URL + '/app/shopping-list/';

    this.getList = function (appId, params) {
        return $http.get(SHOPPING_LIST_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.get = function (listId, appId) {
        return $http.get(SHOPPING_LIST_URL + listId, {params: {application_id: appId}});
    };

    this.createShoppingList = function (list) {
        return $http.post(SHOPPING_LIST_URL, list);
    };

    this.editShoppingList = function (list) {
        return $http.put(SHOPPING_LIST_URL + list.id, list);
    };

    this.remove = function (listId) {
        return $http.delete(SHOPPING_LIST_URL + listId);
    };

}]);

export default shoppingListsServices;
